module.exports = __webpack_public_path__ + "33a4cf68fff7330e5999b5cfe53e5a8e.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/beige/enlexp.png
// module id = 2383
// module chunks = 0